/* ============================================================
   Modern Product Card — behaviour
   - إضافة للسلة بدون Reload
   - تبديل صورة الكارت مع السواتش
   - صورة الهوفر بتتحمّل عند الحاجة بس (توفير داتا على الموبايل)
   ============================================================ */

(function () {
  'use strict';

  const SELECTORS = {
    form: '[data-card-add-form]',
    card: '.card-m',
    media: '.card-m__media',
    mainImg: '.card-m__img--main',
    hoverImg: '.card-m__img--hover',
  };

  // card-modern-boot بيحطه في <head>؛ السطر ده fallback لو السنيبت مش موجود.
  document.documentElement.classList.add('card-m-js');

  /* ---------- إظهار الصورة بعد التحميل ---------- */

  function markLoaded(img) {
    const media = img.closest(SELECTORS.media);
    if (media) media.classList.add('is-loaded');

    const card = img.closest(SELECTORS.card);
    if (card && card.classList.contains('card-m--anim')) maybeReveal(card);
  }

  // الكشف بيحصل بس لما الشرطين يتحققوا: الكارت دخل الشاشة، والصورة خلصت تحميل.
  // من غير كده الحركة بتجري على صورة لسه شفافة ومحدش بيشوفها.
  function maybeReveal(card) {
    if (card.dataset.seen !== '1') return;

    const media = card.querySelector(SELECTORS.media);
    const img = card.querySelector(SELECTORS.mainImg);

    if (img && media && !media.classList.contains('is-loaded')) return;

    card.classList.add('is-visible');
  }

  // listener واحد بالـ capture بيمسك تحميل أي صورة في الصفحة، حتى اللي بتتحقن بالـ AJAX
  // (الفلاتر، الـ pagination، والمنتجات المقترحة) — من غير أي MutationObserver
  document.addEventListener(
    'load',
    function (event) {
      const img = event.target;
      if (img.tagName === 'IMG' && img.classList.contains('card-m__img--main')) markLoaded(img);
    },
    true
  );

  document.addEventListener(
    'error',
    function (event) {
      const img = event.target;
      if (img.tagName === 'IMG' && img.classList.contains('card-m__img--main')) markLoaded(img);
    },
    true
  );

  /*
     الصور المحقونة بعد تحميل الصفحة (التوصيات والفلاتر) تحتاج listener
     مباشر بجانب listener الـ capture العام. ده يتعامل مع اختلاف توقيت
     lazy-loading في WebKit من غير MutationObserver دائم أو polling.
     WeakSet يمنع تكرار الـ listeners، و once يشيلهم فور انتهاء الطلب.
  */
  const watchedImages = new WeakSet();

  function scanMainImages(root) {
    (root || document).querySelectorAll(SELECTORS.mainImg).forEach((img) => {
      if (img.complete) {
        markLoaded(img);
        return;
      }

      if (watchedImages.has(img)) return;
      watchedImages.add(img);
      img.addEventListener('load', () => markLoaded(img), { once: true });
      img.addEventListener('error', () => markLoaded(img), { once: true });
    });
  }

  /* ---------- توست (بيستخدم بس لو مفيش دراور ولا notification) ---------- */

  let toastEl = null;
  let toastTimer = null;

  function showToast(message) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'card-m-toast';
      toastEl.setAttribute('role', 'status');
      toastEl.setAttribute('aria-live', 'polite');
      document.body.appendChild(toastEl);
    }

    toastEl.textContent = message;
    requestAnimationFrame(() => toastEl.classList.add('is-visible'));

    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => toastEl.classList.remove('is-visible'), 2600);
  }

  /* ---------- الوصول لكارت دراور / نوتيفيكيشن بتوع Dawn ---------- */

  function getCartElement() {
    // الدراور له الأولوية، وبعده الـ notification (لو الإعداد متظبط كده)
    return document.querySelector('cart-drawer') || document.querySelector('cart-notification');
  }

  function getSectionIds(cartEl) {
    if (cartEl && typeof cartEl.getSectionsToRender === 'function') {
      return cartEl.getSectionsToRender().map((section) => section.id);
    }
    return ['cart-icon-bubble'];
  }

  function updateCartIconFallback(sectionsHtml) {
    const bubbleHtml = sectionsHtml && sectionsHtml['cart-icon-bubble'];
    const target = document.getElementById('cart-icon-bubble');
    if (!bubbleHtml || !target) return;

    const parsed = new DOMParser().parseFromString(bubbleHtml, 'text/html');
    const fresh = parsed.querySelector('.shopify-section') || parsed.body.firstElementChild;
    if (fresh) target.innerHTML = fresh.innerHTML;
  }

  /* ---------- الإضافة للسلة ---------- */

  document.addEventListener('submit', function (event) {
    const form = event.target.closest(SELECTORS.form);
    if (!form) return;

    event.preventDefault();
    if (form.classList.contains('is-loading')) return;

    const button = form.querySelector('button[type="submit"]');
    const label = form.querySelector('.card-m__quick-label');
    const originalLabel = label ? label.textContent : '';

    const cartEl = getCartElement();
    const sectionIds = getSectionIds(cartEl);

    form.classList.add('is-loading');
    if (button) button.disabled = true;

    fetch(`${window.Shopify.routes.root}cart/add.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
      body: JSON.stringify({
        items: [
          {
            id: Number(form.querySelector('[name="id"]').value),
            quantity: Number((form.querySelector('[name="quantity"]') || { value: 1 }).value || 1),
          },
        ],
        // بنطلب سكاشن السلة في نفس الريكوست — ريكوست واحد بدل اتنين
        sections: sectionIds,
        sections_url: window.location.pathname,
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        form.classList.remove('is-loading');
        if (button) button.disabled = false;

        if (data.status) {
          showToast(data.description || data.message || 'مش قادرين نضيف المنتج دلوقتي');
          return;
        }

        // renderContents بتحدّث محتوى الدراور وبتفتحه لوحدها (نفس اللي بيعمله product-form في Dawn)
        if (cartEl && typeof cartEl.renderContents === 'function') {
          if (cartEl.classList.contains('is-empty')) cartEl.classList.remove('is-empty');
          cartEl.renderContents(data);
        } else {
          updateCartIconFallback(data.sections);
          showToast('اتضاف للسلة');
        }

        if (label) {
          label.textContent = 'اتضاف للسلة ✓';
          form.classList.add('is-added');
          setTimeout(() => {
            form.classList.remove('is-added');
            label.textContent = originalLabel;
          }, 2000);
        }

        document.dispatchEvent(new CustomEvent('card-m:cart-updated', { detail: data }));
      })
      .catch(() => {
        form.classList.remove('is-loading');
        if (button) button.disabled = false;
        showToast('في مشكلة في الاتصال، جرّب تاني');
      });
  });

  /* ============================================================
     أنيميشن الظهور
     ============================================================ */

  const ANIM = {
    observer: null,
    enabled: true,
    STAGGER: 50, // فرق التوقيت بين كل كارت والتاني
    MAX_STEPS: 5, // بحد أقصى 250ms، عشان آخر كارت في الصف ميستناش كتير
  };

  function animationsAllowed() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return false;

    const conn = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
    if (conn && conn.saveData) return false;

    /* ============================================================
       فحص effectiveType اتشال — وده كان سبب "مش شغال على الموبايل
       أول مرة، وبيشتغل بعد الريفريش".

       الحُرّاس التانية كلها ثابتة على نفس الجهاز: تقليل الحركة،
       الرام، عدد الأنوية. مستحيل واحد منهم يخلي التحميل الأول
       يختلف عن الريفريش. effectiveType هي الوحيدة اللي بتتغيّر.

       والسبب إنها **مش** نوع الشبكة: دي تقدير المتصفح محسوب من
       زمن الاستجابة والسرعة. على الموبايل في أول تحميل العينات
       لسه قليلة فالتقدير بيبدأ متشائم ("2g") حتى على خط كويس،
       وبعد الريفريش بيكون اتحسّن. على الكمبيوتر بيبلّغ "4g"
       دايمًا — عشان كده المشكلة مكانتش بتظهر هناك.

       والقرار بيتاخد مرة واحدة في <head> وبيحط card-m-no-anim
       اللي بيفضل طول عمر الصفحة، فحتى لو الشبكة اتحسّنت بعد
       ثانية الأنيميشن بيفضل مقفول.

       والحركة نفسها transition على opacity و transform — بتتنفّذ
       على كارت الشاشة ومبتحمّلش الشبكة ولا بايت. فالربط بينها
       وبين تقدير سرعة النت مكانش في محله من الأساس.

       saveData فضلت: دي اختيار صريح من المستخدم مش تقدير.
       ============================================================ */

    // أجهزة ضعيفة: أقل من 2 جيجا رام أو أقل من 4 أنوية
    if (typeof navigator.deviceMemory === 'number' && navigator.deviceMemory < 2) return false;
    if (typeof navigator.hardwareConcurrency === 'number' && navigator.hardwareConcurrency < 4) return false;

    return true;
  }

  function initAnimations(force) {
    if (ANIM.observer || ANIM.enabled === false) return;

    /*
       صفحة المنتج تبدأ بهيكل التوصيات فقط، ثم تحقن الكروت لاحقًا.
       عدم وجود كارت وقت DOMContentLoaded لا يعني أن الأنيميشن مقفول؛
       نؤجل إنشاء الـ observer لأول دفعة ديناميكية بدل تعطيله نهائيًا.
    */
    if (!force && !document.querySelector('.card-m--anim')) return;

    ANIM.enabled = animationsAllowed() && 'IntersectionObserver' in window;

    if (!ANIM.enabled) {
      document.documentElement.classList.add('card-m-no-anim');
      return;
    }

    ANIM.observer = new IntersectionObserver(
      (entries, observer) => {
        let step = 0;

        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;

          observer.unobserve(entry.target);
          entry.target.dataset.seen = '1';

          // التدرّج بيتحسب على الكروت اللي دخلت الشاشة مع بعض في نفس اللحظة
          if (step > 0) {
            entry.target.style.setProperty(
              '--card-m-delay',
              Math.min(step, ANIM.MAX_STEPS) * ANIM.STAGGER + 'ms'
            );
          }
          step += 1;

          maybeReveal(entry.target);
        });
      },
      {
        // بيشتغل ساعة ما الكارت يبدأ يدخل الشاشة فعلاً — عشان تشوف الحركة
        rootMargin: '0px 0px -5% 0px',
        threshold: 0,
      }
    );
  }

  function armCards(root) {
    const cards = (root || document).querySelectorAll('.card-m--anim:not([data-anim])');
    if (!cards.length) return;

    // Lazy observer: مهم للتوصيات والفلاتر اللي تضيف أول كروت بعد DOMContentLoaded.
    if (!ANIM.observer && ANIM.enabled) initAnimations(true);

    if (!ANIM.enabled || !ANIM.observer) {
      cards.forEach((card) => card.classList.add('is-visible'));
      return;
    }

    cards.forEach((card) => {
      card.dataset.anim = 'set';
      card.classList.add('is-armed');
    });

    // لازم المتصفح يرسم الحالة المبدئية الأول، وإلا الانتقال بيتلغي
    // وتلاقي الكارت ظهر فجأة من غير حركة. الـ rAF المزدوجة بتضمن إطار كامل.
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        cards.forEach((card) => ANIM.observer.observe(card));
      });
    });

    // لو صورة اتعلّقت في التحميل، بنكشف الكارت بعد 4 ثواني على أي حال
    setTimeout(() => {
      cards.forEach((card) => {
        if (card.dataset.seen === '1') card.classList.add('is-visible');
      });
    }, 4000);
  }

  /* واجهة عامة للسكاشن اللي بتحقن كروت بعد تحميل الصفحة */
  window.CardModern = window.CardModern || {};
  window.CardModern.scan = function (root) {
    scanMainImages(root);
    armCards(root);
  };

  /* ---------- التشغيل ---------- */

  function boot() {
    initAnimations();
    scanMainImages();
    armCards();
    document.documentElement.classList.add('card-m-runtime-ready');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', (e) => window.CardModern.scan(e.target));
  document.addEventListener('related-products:loaded', (e) => window.CardModern.scan(e.target));

  /* Theme Editor: stop observing cards removed with their section. */
  document.addEventListener('shopify:section:unload', function (event) {
    if (!ANIM.observer || !event.target || !event.target.querySelectorAll) return;
    event.target.querySelectorAll('.card-m--anim[data-anim]').forEach(function (card) {
      ANIM.observer.unobserve(card);
    });
  });
})();
